// /src/components/Header.js
import React from 'react';

const Header = () => {
  return (
    <header className="header">
      <h1 className="header-title">AI-Powered Test Prep</h1>
    </header>
  );
};

export default Header;